export default {"src":"/_next/static/media/run.1bbccf72.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};